<template>
  <el-dialog
    :before-close="handleClose"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    append-to-body
    :title="title"
    width="80%"
  >
    <div v-if="type == 1">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        stripe
        style="width: 100%;"
        tooltip-effect="dark"
      >
        <el-table-column align="center" label="用户头像" min-width="120">
          <template slot-scope="scope"
            ><img
              :src="scope.row.avatarUrl"
              alt=""
              height="50px"
              width="50px"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="用户昵称"
          min-width="120"
          prop="nickName"
        ></el-table-column>
        <el-table-column
          align="center"
          label="用户手机号"
          min-width="120"
          prop="phone"
        ></el-table-column>
        <el-table-column
          align="center"
          label="性别"
          min-width="100"
          prop="phone"
        >
          <template slot-scope="{ row }">
            <span v-if="row.gender == 1">
              男
            </span>
            <span v-if="row.gender == 2">
              女
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="位置"
          min-width="200"
          prop="address"
        ></el-table-column>
        <el-table-column
          align="center"
          label="注册时间"
          min-width="160"
          prop="createTime"
        ></el-table-column>
      </el-table>
    </div>

    <div v-if="type == 2 || type == 3">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        stripe
        style="width: 100%;"
        tooltip-effect="dark"
      >
        <el-table-column
          align="center"
          label="商品名"
          min-width="120"
          prop="name"
        ></el-table-column>
        <el-table-column align="center" label="封面" min-width="120">
          <template slot-scope="scope"
            ><img :src="scope.row.cover" alt="" height="50px" width="50px" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="分类"
          min-width="120"
          prop="nickName"
        >
          <template slot-scope="scope">
            {{ scope.row.firstClassifyName }}/ {{ scope.row.classifyName }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="数量"
          min-width="120"
          prop="num"
        ></el-table-column>
      </el-table>
    </div>
    <div v-if="type == 4 || type == 5 || type == 6">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        stripe
        style="width: 100%;"
        tooltip-effect="dark"
      >
        <el-table-column
          align="center"
          label="订单号"
          min-width="120"
          prop="orderCode"
        ></el-table-column>
        <el-table-column
          label="实付金额"
          align="center"
          prop="realPayment"
          width="120"
        ></el-table-column>
        <el-table-column
          label="收货人"
          align="center"
          prop="name"
          width="240"
        ></el-table-column>
        <el-table-column
          label="收货地址"
          align="center"
          prop="deliveryMethod"
          width="240"
        >
          <template slot-scope="scope">
            {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.county
            }}{{ scope.row.address }}
          </template>
        </el-table-column>

        <el-table-column
          label="物流单号"
          align="center"
          prop="logisticsNumber"
          width="240"
        ></el-table-column>
        <el-table-column
          label="下单时间"
          align="center"
          prop="payTime"
          width="200"
        ></el-table-column>
      </el-table>
    </div>

    <div style="height: 50px;">
      <el-pagination
        :current-page="current"
        :page-size="size"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "Detail",
  components: {},
  data() {
    return {
      title: "",
      dialogVisible: false,
      tableData: [],
      userId: null,
      total: 0,
      size: 10,
      current: 1,
      type: null,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
      this.getType();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getType();
    },
    handleClose() {
      this.dialogVisible = false;
      this.size = 10;
      this.current = 1;
      this.tableData = [];
    },

    getUserList() {
      this.$axios
        .post("/admin/userBase/getShareUserList", {
          pageNo: this.current,
          pageSize: this.size,
          userId: this.userId,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },

    getBrowseList() {
      this.$axios
        .post("/admin/num/getBrowseList", {
          pageNo: this.current,
          pageSize: this.size,
          userId: this.userId,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    getShoppingCartList() {
      this.$axios
        .post("/admin/num/getShoppingCartList", {
          pageNo: this.current,
          pageSize: this.size,
          userId: this.userId,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    getOrderList() {
      this.$axios
        .post("/admin/order/getOrderList", {
          pageNo: this.current,
          pageSize: this.size,
          userId: this.userId,
          orderType: this.type == 4 ? 0 : this.type == 5 ? 9 : 3,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },

    getType() {
      switch (this.type) {
        case 1:
          this.title = "拉新并下单人数";
          this.getUserList();
          break;
        case 2:
          this.title = "浏览商品";
          this.getBrowseList();
          break;
        case 3:
          this.title = "购物车商品";
          this.getShoppingCartList();
          break;
        case 4:
          this.title = "未付款订单";
          this.getOrderList();
          break;
        case 5:
          this.title = "已付款订单";
          this.getOrderList();
          break;
        case 6:
          this.title = "已完成订单";
          this.getOrderList();
          break;
        default:
          break;
      }
    },

    init(options) {
      this.userId = options.userId;
      this.type = options.type;
      this.getType();
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped></style>
